import { T } from "../../hooks/useTranslate";

import { Box, Typography } from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";

import { CopyToClipboard } from "../CopyToClipboard";

import {
  gridTextStyle,
  gridChildLeftWrapper,
} from "./drawer-styles";


const ProfileEmailLine = ({ customerHrefData, drawerType, eventLocation }) => {
  return (
    <>
      <Box sx={gridChildLeftWrapper}>
        <MailIcon sx={{ height: 14, width: 14 }} />
      </Box>
      {customerHrefData.email !== "" ? (
        <Box component="span" sx={{ fontSize: "calc(12px * var(--unicity-font-scale, 1))", textDecoration: "underline" }}>          
          <CopyToClipboard
            text={customerHrefData?.email}
            stringToCopy={customerHrefData?.email}
            iconId={`${drawerType}-profile-copy-email`}
            eventName="email_copy"
            eventLocation={eventLocation}
            sendEvent={true}
            userType={drawerType}
            userId={customerHrefData.unicity}
          />
        </Box>
      ) : (
        <Typography sx={gridTextStyle} data-testid={`${drawerType}-profile-email`}>
          <T>not_available</T>
        </Typography>
      )}
    </>
  )
}

export { ProfileEmailLine }